import ButtonLink from 'sd-ui/dist/commonjs/components/ButtonLink/ButtonLink';
import React, {
  useCallback,
  useContext,
} from 'react';
import PropTypes from 'prop-types';
import PanelContext from '../sidebar/panel/panelContext';
import { panelType } from '../../../shared/constants';

export default function FigureTitle({ activeIndex, totalItems }) {
  const { openPanel } = useContext(PanelContext);

  const openFigures = useCallback(() => {
    openPanel({ component: panelType.figures, index: 0 });
  }, [openPanel]);

  return (
    <div className="figure-title">
      <ButtonLink onClick={openFigures} icon={null}>Figures</ButtonLink>
      {` (${activeIndex + 1} of ${totalItems})`}
    </div>
  );
}

FigureTitle.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
};
